import React from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { HeartIcon } from "@heroicons/react/24/outline";
import { HeartIcon as HeartIconSolid } from "@heroicons/react/24/solid";
import { toast } from "react-hot-toast";

const ProductCard = ({ product }) => {
  const dispatch = useDispatch();
  const wishlist = useSelector(state => state.wishlist);
  const isInWishlist = wishlist.items.some(item => item.id === product._id);

  const handleWishlistClick = (e) => {
    e.preventDefault();
    if (isInWishlist) {
      dispatch({ type: 'REMOVE_FROM_WISHLIST', payload: product._id });
      toast.success('Removed from wishlist');
    } else {
      dispatch({ 
        type: 'ADD_TO_WISHLIST', 
        payload: {
          id: product._id,
          name: product.productName,
          price: product.sellingPrice,
          image: product.images?.[0],
          color: product.color
        }
      });
      toast.success('Added to wishlist');
    }
  };

  if (!product) return null;

  return (
    <div className="group relative">
      <Link to={`/product/${product._id}`}>
        <div className="w-[288px] h-[448px] overflow-hidden mb-4">
          <img
            src={product.images?.[0]}
            alt={product.productName}
            className="w-full h-full object-cover hover:scale-105 transition-transform duration-300"
          />
        </div>
        <div className="space-y-1">
          <h3 className="text-sm text-gray-800">{product.productName}</h3>
          <div className="flex items-center gap-2">
            <p className="text-sm text-gray-900">₹{product.sellingPrice.toFixed(2)}</p>
            {product.actualPrice > product.sellingPrice && (
              <>
                <p className="text-xs text-gray-500 line-through">₹{product.actualPrice.toFixed(2)}</p>
                <p className="text-xs text-green-600">
                  {Math.round(((product.actualPrice - product.sellingPrice) / product.actualPrice) * 100)}% OFF
                </p>
              </>
            )}
          </div>
          <div className="flex items-center justify-between">
            {product.customization && (
              <p className="text-xs text-gray-500">Customization</p>
            )}
            {product.color && (
              <div className="flex gap-1">
                <span
                  className="w-3 h-3 rounded-full"
                  style={{ backgroundColor: product.color.toLowerCase() }}
                />
              </div>
            )}
          </div>
          {product.status && (
            <p className="text-xs text-gray-500">{product.status}</p>
          )}
        </div>
      </Link>
      <button
        onClick={handleWishlistClick}
        className="absolute top-4 right-4 p-2 bg-white rounded-full shadow-md opacity-0 group-hover:opacity-100 transition-opacity duration-300"
      >
        {isInWishlist ? (
          <HeartIconSolid className="w-5 h-5 text-red-500" />
        ) : (
          <HeartIcon className="w-5 h-5 text-gray-600" />
        )}
      </button>
    </div>
  );
};

export default ProductCard;
